import { render, staticRenderFns } from "./ImmediateDesignButton.vue?vue&type=template&id=24183532&scoped=true"
import script from "./ImmediateDesignButton.vue?vue&type=script&lang=js"
export * from "./ImmediateDesignButton.vue?vue&type=script&lang=js"
import style0 from "./ImmediateDesignButton.vue?vue&type=style&index=0&id=24183532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24183532",
  null
  
)

export default component.exports